import { render, staticRenderFns } from "./ApproveJobBtn.vue?vue&type=template&id=c88448b2&scoped=true&"
import script from "./ApproveJobBtn.vue?vue&type=script&lang=js&"
export * from "./ApproveJobBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c88448b2",
  null
  
)

export default component.exports